import $ from 'jquery';

export default function CookieBanner() {
    $(function () {
        var cookieInfo = getCookie("hidecookie");
        if (cookieInfo !== "1" && cookieInfo !== "2") {
            $(".cookie-banner").css("opacity", 0.94);
        }
        else {
            setTimeout(function () { $(".cookie-banner").css("display", "none"); }, 1000);
        }

        $(".js-banner-1").on("click", function () {
            setCookie("hidecookie", 1, 364);
            $(".cookie-banner").css("opacity", 0);
            setTimeout(function () {
                $(".cookie-banner").css("display", "none");
                window.location.reload();
            }, 1000);

        })
        $(".js-banner-2").on("click", function () {
            setCookie("hidecookie", 2, 364);

            $(".cookie-banner").css("opacity", 0);
            setTimeout(function () { $(".cookie-banner").css("display", "none"); }, 1000);
        })
    });
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


function setCookie(cname, cvalue, exdays) {
    var cookie = cname + "=" + cvalue + ";";
    if (exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        cookie = cookie + "expires=" + d.toUTCString() + ";";
    }
    cookie = cookie + "path=/";
    document.cookie = cookie;

}